<!-- @format -->

<genres>
  <style>
    ul.checkbox_list {
      display: flex;
      flex-wrap: wrap;
    }
  </style>

  <!--/.accordion_heading02-->

  <div class="container_accordion">
    <div class="accordion_heading is-hide" data-group="genres">
      <div class="checkbox_wrap">
        <input
          type="checkbox"
          id="genre_all"
          class="checkbox-input"
          onclick="{ onCheckAll }"
        />
        <label for="genre_all" class="checkbox-parts">関心のあるジャンル</label>
      </div>
      <div class="js-accordion"></div>
    </div>

    <div class="accordion_body" data-group="genres" style="display: none">
      <ul class="checkbox_list margin-spacing-1_top">
        <li
          class="checkbox_list-item"
          each="{ genre in props.master }"
          if="{ genre.id > 0 && genre.name !== 'other' }"
        >
          <input
            class="checkbox-input media-publication"
            type="checkbox"
            checked="{ props.data.isChecked(genre.id) }"
            id="genre_id_{ genre.id }"
            value="{ genre.id }"
            onclick="{ e => onCheck(e, genre.id) }"
          />
          <label for="genre_id_{ genre.id }" class="checkbox-parts">
            { genre.jname }
          </label>
        </li>
      </ul>

      <template
        each="{ genre in props.master }"
        if="{ genre.name === 'other' }"
      >
        <ul class="checkbox_list margin-spacing-1_top">
          <li class="checkbox_list-item">
            <input
              class="checkbox-input js-check_skill-other"
              type="checkbox"
              checked="{ props.data.isChecked(genre.id) }"
              id="genre_id_{ genre.id }"
              value="{ genre.id }"
              onclick="{ e => onCheck(e, genre.id) }"
            />
            <label for="genre_id_{ genre.id }" class="checkbox-parts">
              { genre.jname }
            </label>
          </li>
        </ul>
        <div class="box_w50">
          <input
            class="text_input input_skill-other"
            type="text"
            value="{ props.data.getMemo(genre.id) }"
            disabled="{ !props.data.isChecked(genre.id) }"
            oninput="{ e => onText(e, genre.id) }"
          />
        </div>
        <div if="{ props.errors && props.errors[genre.id] }" class="error">
          { props.errors[genre.id] }
        </div>
      </template>
    </div>
    <!--/.accordion_body-->
  </div>
  <!--/.container_accordion-->

  <script>
    export default {
      onMounted(props, state) {
        if (props.data.isCheckedGroup()) {
          this.$(`.accordion_heading`).classList.remove("is-hide");
          this.$(`.accordion_body`).style.display = "block";
        }
      },
      onCheckAll(e) {
        let data = this.props.data;
        for (const genre of this.props.master) {
          if (genre.name !== "other" && genre.id > 0) {
            data.update({
              id: genre.id,
              checked: e.target.checked,
            });
          }
        }
        this.props.onUpdate(data);
      },
      onCheck(e, id) {
        let data = this.props.data;
        data.update({ id, checked: e.target.checked });
        this.props.onUpdate(data);
      },
      onText(e, id) {
        let data = this.props.data;
        data.update({ id, memo: e.target.value });
        this.props.onUpdate(data);
      },
    };
  </script>
</genres>
